import BrandList from "../vehicle-brand-list";
import ModelsList from "../vehicle-model-list";
// import { vehicleAccordionReduxKeyNames } from "../pre-delivery-inspection/constants";

export const STEP_NAMES = {
    Brand: "brand",
    Model: "model"
};

export const STEP_LIST = [
    {
        name: STEP_NAMES.Brand,
        label: "Brand",
        Component: BrandList,
        reduxStateKey: STEP_NAMES.Brand
    },
    {
        name: STEP_NAMES.Model,
        label: "Model",
        Component: ModelsList,
        reduxStateKey: STEP_NAMES.Model
    }
];
